import { addMonthsToDateOnly, currentBusinessDate, dateOnlyFromValue } from "./timezone";

const getLastMonthsRange = (dateString) => {
  const endDate = dateOnlyFromValue(dateString || currentBusinessDate());
  return [addMonthsToDateOnly(endDate, -12), endDate];
};
export default getLastMonthsRange;
